import { useGetRecurringFees } from 'components/billing/context/useBilling';
import { useInfinityTestingBillingStatus } from './useInfinityTestingBillingStatus';

export const useInfinityTestingPlatformFee = () => {
  const { trialPlatformFeeAmount } = useInfinityTestingBillingStatus();
  const { data: feeData } = useGetRecurringFees({
    type__eq: 'MARKETING_AI',
  });

  // remove soft-deleted fees (end_date < start_date)
  // sort by start_date __DESCENDING__
  const currentFees = feeData?.length
    ? feeData
        .filter((fee) => {
          return new Date(fee.endDate) > new Date(fee.startDate);
        })
        .sort((a, b) => {
          return (
            new Date(b.startDate).getTime() - new Date(a.startDate).getTime()
          );
        })
    : [];

  // use first element of the sorted array or fallback to trial amount or default
  return currentFees?.[0]?.amountCents ?? trialPlatformFeeAmount ?? 69900;
};
